<template>
  <div>
    <b>{{ valuesConvert.title }}</b>
    <ul v-if="valuesConvert.actions">
      <li
        v-for="(action, index) in valuesConvert.actions"
        :key="`${action.key}_${index}`">
        {{ action.label }}
        <template v-if="action.value">
          <ul v-if="action.key === 'sendEmail'">
            <li
              v-for="(email, emailIndex) in action.value.Emails"
              :key="`${email}_${emailIndex}`">
              {{ email }}
            </li>
          </ul>
          <ul v-else-if="action.key === 'generateReport'">
            <li
              v-for="(documentTitle, documentTitleIndex) in action.value.DocumentTitles"
              :key="`${documentTitle}_${documentTitleIndex}`">
              {{ documentTitle }}
            </li>
          </ul>
          <ul v-else-if="action.key === 'updateOfferPeriodEndDate' && action.value.newValueStr">
            {{ action.value.newValueStr }}
          </ul>
          <template v-else-if="action.key === 'updateAdditionalField'">
            <u><b>{{ action.value.caption }}</b></u>
            <template v-if="action.value.typeId === 'DATE_TIME'">
              <div>{{ $t('Common.From') }}: {{ $d(new Date(action.value.OldValue), "shortDate") }}</div>
              <div>{{ $t('Common.To') }}: {{ $d(new Date(action.value.NewValue), "shortDate") }}</div>
            </template>
            <template v-else-if="action.value.OldValue">
              <div>{{ $t('Common.From') }}: {{ action.value.OldValue }}</div>
              <div>{{ $t('Common.To') }}: {{ action.value.NewValue }}</div>
            </template>
            <template v-else>
              {{ action.value.NewValue }}
            </template>
          </template>
          <template v-else>
            {{ action.value }}
          </template>
        </template>
      </li>
    </ul>
  </div>
</template>
<script>
import textFunctions from 'mixins/textFunctions'

export default {
  name: 'EventHistoryAutomationProps',
  mixins: [ textFunctions ],
  data() {
    return {
      valuesConvert: {
        title: '',
        actions: []
      }
    }
  },
  methods: {
    getDopProps(item) {
      if (item.ActionType === 'UPDATE_ADDITIONAL_FIELD' && this.spr?.additionalFields?.length && item.Value.AdditionalFieldId) {
        return this.spr?.additionalFields.find(i => i.id === item.Value.AdditionalFieldId)
      } else if (item.ActionType === 'UPDATE_OFFER_PERIOD_END_DATE') {
        let newValueStr = ''
        try {
          newValueStr = `${this.$d(new Date(item.Value.NewDate ?? item.Value.NewValue), 'shortDate')} ${this.$d(new Date(item.Value.NewDate ?? item.Value.NewValue), 'time')}`
        } catch (_) {
          return
        }
        return {
          newValueStr,
        }
      }
      return {}
    },
    createValuesConvert() {
      this.valuesConvert = {
        title: this.value.Title,
        actions: this.value.Actions?.map(i => {
          const action = this.$_convertToCamelCase(i.ActionType)
          const value = Object.keys(i.Value)?.length ? i.Value : null
          const dopProps = this.getDopProps(i)
          let merged = { ...value, ...dopProps }

          if (!merged || (typeof merged === 'object' && Object.keys(merged).length === 0)) {
            merged = ''
          }
          return {
            key: action,
            label: this.$t('Automation.action.' + action),
            value: merged
          }
        })
      }
    }
  },
  props: {
    value: {
      type: Object
    },
    spr: {
      type: Object
    }
  },
  watch: {
    'spr.additionalFields': {
      immediate: true,
      deep: true,
      handler() {
        this.createValuesConvert()
      }
    }
  },
  async mounted() {
    this.createValuesConvert()
  }
}
</script>
